/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */



import { Component, Input, Output, EventEmitter, ElementRef, Renderer, HostBinding, HostListener, ViewEncapsulation } from '@angular/core';
import { Inject, Optional, Host, forwardRef } from '@angular/core';

import classNames from 'classnames';

import { Select } from './select';
export class Option {
public isSelectOption = true;
/**
 * 样式前缀
 */
prefixCls = 'ant-select-dropdown-menu';
/**
 * 值。默认根据此属性值进行筛选
 */
value: any;
/**
 * title
 */
title = '';
/**
 * 是否禁用状态，默认为 false
 */
disabled = false;
/**
 * id
 */
id: string;
/**
 * option click 事件，参数为：({ option, event })
 */
optionClick = new EventEmitter<{ event: Event, option: Option }>();


     role = 'menuitem';
     unselectable = 'unselectable';
/**
 * @param {?} renderer
 * @param {?} elementRef
 * @param {?} select
 */
constructor(
private renderer: Renderer,
private elementRef: ElementRef,
private select: Select) {
            this.id = select.registerOption(this);
    }
/**
 * 菜单样式
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classes = classNames(`${this.prefixCls}-item`, {
            [`${this.prefixCls}-item-selected`]: this.isSelected(),
            [`${this.prefixCls}-item-active`]: !this.disabled && this.isActived(),
            [`${this.prefixCls}-item-disabled`]: this.disabled
        });
        return classes;
    }
/**
 * @return {?}
 */
get ariaselected(): any {
        return this.isSelected() ? 'true' : null;
    }
/**
 * @return {?}
 */
get ariadisabled(): any {
        return this.disabled ? 'true' : null;
    }
/**
 * @return {?}
 */
get myId(): any {
        return this.id;
    }
/**
 * @param {?} event
 * @return {?}
 */
onMouseEnter(event: MouseEvent): void {
        if (this.disabled) {
            return;
        }
        this.select.activedOption = this;
    }
/**
 * @param {?} event
 * @return {?}
 */
onMouseLeave(event: MouseEvent): void {
        if (this.disabled) {
            return;
        }
        this.select.activedOption = null;
    }
/**
 * @param {?} event
 * @return {?}
 */
onClick(event: MouseEvent): void {
        if (this.disabled) {
            return;
        }
        this.optionClick.emit({ event: event, option: this });
    }
/**
 * 是否已选择
 * @return {?}
 */
isSelected(): boolean {
        return this.select.isOptionSelected(this);
    }
/**
 * 是否已激活
 * @return {?}
 */
isActived(): boolean {
        return this.select.isOptionActived(this);
    }
/**
 * 获取Option的文本
 * @return {?}
 */
getText(): string {
        if (this.elementRef) {
            return this.elementRef.nativeElement.innerText.trim();
        }
        return this.title;
    }
/**
 * text属性，直接取getText()的值
 * @return {?}
 */
get text(): string {
        return this.getText();
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-option',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: Select, decorators: [{ type: Inject, args: [forwardRef(() => Select), ] }, { type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'value': [{ type: Input },],
'title': [{ type: Input },],
'disabled': [{ type: Input },],
'id': [{ type: Input },],
'optionClick': [{ type: Output },],
'role': [{ type: HostBinding, args: ['attr.role', ] },],
'unselectable': [{ type: HostBinding, args: ['attr.unselectable', ] },],
'classes': [{ type: HostBinding, args: ['class', ] },],
'ariaselected': [{ type: HostBinding, args: ['attr.aria-selected', ] },],
'ariadisabled': [{ type: HostBinding, args: ['attr.aria-disabled', ] },],
'myId': [{ type: HostBinding, args: ['attr.id', ] },],
'onMouseEnter': [{ type: HostListener, args: ['mouseenter', ['$event'], ] },],
'onMouseLeave': [{ type: HostListener, args: ['mouseleave', ['$event'], ] },],
'onClick': [{ type: HostListener, args: ['click', ['$event'], ] },],
};
}

function Option_tsickle_Closure_declarations() {
/** @type {?} */
Option.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Option.ctorParameters;
/** @type {?} */
Option.propDecorators;
/** @type {?} */
Option.prototype.isSelectOption;
/**
 * 样式前缀
 * @type {?}
 */
Option.prototype.prefixCls;
/**
 * 值。默认根据此属性值进行筛选
 * @type {?}
 */
Option.prototype.value;
/**
 * title
 * @type {?}
 */
Option.prototype.title;
/**
 * 是否禁用状态，默认为 false
 * @type {?}
 */
Option.prototype.disabled;
/**
 * id
 * @type {?}
 */
Option.prototype.id;
/**
 * option click 事件，参数为：({ option, event })
 * @type {?}
 */
Option.prototype.optionClick;
/** @type {?} */
Option.prototype.role;
/** @type {?} */
Option.prototype.unselectable;
/** @type {?} */
Option.prototype.renderer;
/** @type {?} */
Option.prototype.elementRef;
/** @type {?} */
Option.prototype.select;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
